import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

// Action Types
export const SET_GUILD_PAGE_LOADING = 'SET_GUILD_PAGE_LOADING';

export type TSetGuildPageLoadingAction = TAction<boolean>;

// Action Creators
export function createActionSetGuildPageLoading(payload: boolean): TSetGuildPageLoadingAction {
  return {
    payload,
    type: SET_GUILD_PAGE_LOADING
  };
}
